function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import moment from "moment-timezone";
import React from "react";
import Modal from "react-bootstrap/Modal";
import { HiPlay, HiOutlineX, HiArrowCircleLeft, HiArrowCircleRight, HiUser, HiOutlineClock, HiOutlinePlusCircle, HiOutlineExclamationCircle } from "react-icons/hi";
import { FilterContext, UserContext } from "../index";
import UserSidemenu from "../SideMenu/UserSidemenu";
import { TIMELAPSE_VIDEO_QUERY, UPDATE_TIMELAPSE_SETTINGS_MUTATION, DELETE_TIMELAPSE_VIDEOS_MUTATION, TIMELAPSE_DATA_EXPORT_QUERY, GENERATE_TIMELAPSE_VIDEO_MUTATION, CHECK_TIMELAPSE_VIDEO_GENERATED_QUERY } from "./query";
import Button from "react-bootstrap/Button";
import "./Timelapse.css";
import { arrayToStringOutput } from "./../SideMenu/Header";
import Loader from "./../Loader/Loader";
import { WEB_ORGANISATION_SETTINGS_QUERY, WORK_DAY_SETTINGS_QUERY } from "../TimesheetSettings/query";
import Form from "react-bootstrap/Form";
import { MdTimelapse, MdRefresh } from "react-icons/md";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { RiVideoAddFill } from "react-icons/ri";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
var LIMIT = 10;
var offset = 0;
var Timelapse = function Timelapse(props) {
  var _match$params, _timelapseData$timela8, _videos$, _videos$$user, _videos;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedVideo = _React$useState2[0],
    selectVideo = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    urls = _React$useState4[0],
    setUrls = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    urlIds = _React$useState6[0],
    setUrlIds = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    showBulkDeleteModal = _React$useState8[0],
    setShowBulkDeleteModal = _React$useState8[1];
  var _React$useState9 = React.useState("unchecked"),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    selectAllButton = _React$useState10[0],
    setSelectAllButton = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    exportLoad = _React$useState12[0],
    setExportLoad = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    exportValue = _React$useState14[0],
    setExportValue = _React$useState14[1];
  var _React$useState15 = React.useState([]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    timelapseGeneratedData = _React$useState16[0],
    setTimelapseGeneratedData = _React$useState16[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  // const { teamId, organisationId, startDate, endDate, organisationSettings } = React.useContext(FilterContext);
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var Link = props.linkComponent,
    linkProps = props.linkProps,
    match = props.match,
    Redirect = props.redirect,
    teamId = props.teamId,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    organisationSettings = props.organisationSettings,
    role = props.role,
    organisationBilling = props.organisationBilling;
  var loadPage = organisationSettings.screenCapture;
  var url = role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? user === null || user === void 0 ? void 0 : user.uniqueUrl : (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.url;
  var handleClose = function handleClose() {
    selectVideo(false);
    selectVideo(null);
  };
  var handleShow = function handleShow(value, videoIndex, displayName, profileUrl, videoCount, index, videoList) {
    selectVideo(_objectSpread(_objectSpread({}, value), {}, {
      videoIndex: videoIndex,
      displayName: displayName,
      profileUrl: profileUrl,
      videoCount: videoCount,
      index: index,
      videoList: videoList
    }));
  };
  var dateFilter = arrayToStringOutput([startDate, endDate !== null && endDate !== void 0 ? endDate : startDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);

  // Timelapse videos are built from completed days, so a date that has not
  // arrived yet can never have one. Without this the page fell back to showing
  // yesterday's cards under the future date's heading.
  var isFutureRange = moment(startDate).tz((organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) || moment.tz.guess()).startOf("day").isAfter(moment().tz((organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) || moment.tz.guess()).endOf("day"));
  var startTime = Number(moment(startDate).format("x"));
  var endTime = Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x"));
  var _useQuery = useQuery(TIMELAPSE_VIDEO_QUERY, {
      variables: {
        startDate: startTime,
        endDate: endTime,
        organisationId: organisationId,
        teamId: !url ? teamId : null,
        userId: role === "Member" || role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? user.userId : null,
        url: role !== "Member" || role === "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? url : null,
        userRole: role,
        dateFilter: dateFilter,
        tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0
      },
      skip: !organisationId || !teamId || !loadPage
    }),
    timelapseData = _useQuery.data,
    timelapseError = _useQuery.error,
    timelapseLoading = _useQuery.loading,
    refetch = _useQuery.refetch,
    timelapeFetchMore = _useQuery.fetchMore;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  React.useEffect(function () {
    setUrls([]);
    setUrlIds([]);
    setSelectAllButton("unchecked");
  }, [teamId, startDate, endDate]);
  var _useLazyQuery = useLazyQuery(TIMELAPSE_DATA_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportLoad(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var _useLazyQuery3 = useLazyQuery(CHECK_TIMELAPSE_VIDEO_GENERATED_QUERY, {
      fetchPolicy: "network-only"
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    checkTimelapseVideo = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    checkTimelapseVideoLoading = _useLazyQuery4$.loading,
    checkTimelapseVideoData = _useLazyQuery4$.data;
  var _useMutation = useMutation(GENERATE_TIMELAPSE_VIDEO_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    generateTimelapseVideo = _useMutation2[0],
    generateTimelapseLoading = _useMutation2[1].loading;
  var handleZipFile = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var count, zip, i, sliceSize, byteCharacters, byteArrays, _offset, slice, byteNumbers, _i, byteArray, blob, imageFile, arrSplit, filename, currDate, dateWithOffset;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (exportData) {
            count = 0;
            zip = new JSZip();
            for (i = 0; i < exportData.timelapseDataExport.length; i++) {
              sliceSize = 512;
              byteCharacters = atob(exportData.timelapseDataExport[i]);
              byteArrays = [];
              for (_offset = 0; _offset < byteCharacters.length; _offset += sliceSize) {
                slice = byteCharacters.slice(_offset, _offset + sliceSize);
                byteNumbers = new Array(slice.length);
                for (_i = 0; _i < slice.length; _i++) {
                  byteNumbers[_i] = slice.charCodeAt(_i);
                }
                byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
              }
              blob = new Blob(byteArrays, {
                type: "image/png"
              });
              imageFile = new File([blob], "filename.jpg");
              arrSplit = urls[i].split("/");
              filename = arrSplit[arrSplit.length - 1];
              currDate = new Date();
              dateWithOffset = new Date(currDate.getTime() - currDate.getTimezoneOffset() * 60000);
              zip.file(filename, imageFile, {
                binary: true,
                date: dateWithOffset
              });
              count++;
              if (count === exportData.timelapseDataExport.length) {
                /* Generate a zip file asynchronously and trigger the download */
                zip.generateAsync({
                  type: "blob"
                }).then(function (content) {
                  return saveAs(content, "workfolio-timelapse");
                });
              }
            }
            setExportLoad(false);
          }
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportData]);
  React.useEffect(function () {
    handleZipFile();
    setExportValue(exportData);
  }, [exportData]);
  React.useEffect(function () {
    if (selectAllButton === "checked") {
      setUrls([]);
      var timelapseArr = [];
      var timelapseId = [];
      for (var index = 0; index < (timelapseData === null || timelapseData === void 0 ? void 0 : (_timelapseData$timela = timelapseData.timelapseVideos) === null || _timelapseData$timela === void 0 ? void 0 : (_timelapseData$timela2 = _timelapseData$timela.timelapseVideos) === null || _timelapseData$timela2 === void 0 ? void 0 : _timelapseData$timela2.length); index++) {
        var _timelapseData$timela, _timelapseData$timela2;
        for (var tIndex = 0; tIndex < (timelapseData === null || timelapseData === void 0 ? void 0 : (_timelapseData$timela3 = timelapseData.timelapseVideos) === null || _timelapseData$timela3 === void 0 ? void 0 : (_timelapseData$timela4 = _timelapseData$timela3.timelapseVideos[index]) === null || _timelapseData$timela4 === void 0 ? void 0 : (_timelapseData$timela5 = _timelapseData$timela4.videoData) === null || _timelapseData$timela5 === void 0 ? void 0 : _timelapseData$timela5.length); tIndex++) {
          var _timelapseData$timela3, _timelapseData$timela4, _timelapseData$timela5, _timelapseData$timela6, _timelapseData$timela7;
          var element = timelapseData === null || timelapseData === void 0 ? void 0 : (_timelapseData$timela6 = timelapseData.timelapseVideos) === null || _timelapseData$timela6 === void 0 ? void 0 : (_timelapseData$timela7 = _timelapseData$timela6.timelapseVideos[index]) === null || _timelapseData$timela7 === void 0 ? void 0 : _timelapseData$timela7.videoData[tIndex];
          if ((element === null || element === void 0 ? void 0 : element.videoUrl) != null && (element === null || element === void 0 ? void 0 : element.videoUrl) != "no_screenshot_found" && (element === null || element === void 0 ? void 0 : element.videoUrl) != "cron_list") timelapseArr.push(element === null || element === void 0 ? void 0 : element.videoUrl);
          timelapseId.push(element === null || element === void 0 ? void 0 : element.id);
        }
      }
      setUrls(timelapseArr);
      setUrlIds(timelapseId);
    } else {
      setUrls([]);
      setUrlIds([]);
    }
  }, [selectAllButton]);
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if (timelapseLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (timelapseError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!(timelapseData !== null && timelapseData !== void 0 && timelapseData.timelapseVideos)) {
    return null;
  }
  var videos = (_timelapseData$timela8 = timelapseData.timelapseVideos) === null || _timelapseData$timela8 === void 0 ? void 0 : _timelapseData$timela8.timelapseVideos;
  if (videos) {
    var myData = _toConsumableArray(videos);
    myData.sort(function (a, z) {
      if (a.user.displayName < z.user.displayName) {
        return -1;
      }
      if (a.user.displayName > z.user.displayName) {
        return 1;
      }
      return 0;
    });
    videos = myData;
  }
  var handleNext = function handleNext() {
    var index = selectedVideo.index;
    selectVideo(_objectSpread(_objectSpread({}, videoList), {}, {
      displayName: selectedVideo.displayName,
      videoIndex: Number(selectedVideo.videoIndex) + 1,
      videoCount: selectedVideo.videoCount,
      videoList: selectedVideo.videoList,
      profileUrl: selectedVideo.profileUrl
    }));
  };
  var handlePrevious = function handlePrevious() {
    var index = selectedVideo.index;
    var videoList = selectedVideo.videoList[index - 1];
    selectVideo(_objectSpread(_objectSpread({}, videoList), {}, {
      displayName: selectedVideo.displayName,
      videoIndex: Number(selectedVideo.videoIndex) - 1,
      videoCount: selectedVideo.videoCount,
      videoList: selectedVideo.videoList,
      profileUrl: selectedVideo.profileUrl
    }));
  };
  var selectedVideoUrl = function selectedVideoUrl(url, ids, thumbnailUrl) {
    setUrls(function (prev) {
      return prev.includes(url) ? prev.filter(function (a) {
        return a !== url;
      }) : [].concat(_toConsumableArray(prev), [url]);
    });
    setUrlIds(function (prev) {
      return prev.includes(ids) ? prev.filter(function (a) {
        return a !== ids;
      }) : [].concat(_toConsumableArray(prev), [ids]);
    });
  };
  var selectAll = function selectAll(e) {
    if (selectAllButton === "checked") {
      setSelectAllButton("unchecked");
    } else {
      setSelectAllButton("checked");
    }
  };
  var handleBulkDeleteClose = function handleBulkDeleteClose() {
    setShowBulkDeleteModal(null);
    setSelectAllButton("unchecked");
  };
  var handleBulkDeleteShow = function handleBulkDeleteShow() {
    //const temp = { screenshotId, appTitle, organisationId, teamId };
    if (urlIds.length !== 0) {
      setShowBulkDeleteModal(true);
    }
  };
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var arr, i, splitArr, t;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (urls.length !== 0) {
              setExportLoad(true);
              arr = [];
              for (i = 0; i < urls.length; i++) {
                splitArr = urls[i].split("/");
                t = splitArr[Number(splitArr.length) - 2] + "/" + splitArr[Number(splitArr.length) - 1];
                arr.push(t);
              }
              getExport({
                variables: {
                  timelapseUrls: arr
                }
              });
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var headerName = role == "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo || url || role == "Member" ? (_videos$ = videos[0]) === null || _videos$ === void 0 ? void 0 : (_videos$$user = _videos$.user) === null || _videos$$user === void 0 ? void 0 : _videos$$user.displayName : "Team";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timelapse-root"
  }, !organisationSettings.generateTimelapseVideo ? /*#__PURE__*/React.createElement(TimelapseEnableFeature, {
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    organisationId: organisationId,
    startTime: startTime,
    endTime: endTime,
    url: url,
    teamId: teamId,
    user: user,
    role: role,
    organisationSettings: organisationSettings
  }) :
  /*#__PURE__*/
  // : videos.length == 0 ? (
  //   // <div className="timelapse-warning-text">Timelapse is getting generated. Please check after some time.</div>
  //   <div className="timelapse-no-data-text">No data found !!!</div>
  // )
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", {
    className: "font-weight-bold text-dark"
  }, headerName, "'s Timelapse"), role == "Admin" && dateFilter != "Today" && !isFutureRange ? /*#__PURE__*/React.createElement("div", {
    className: "timelapse-card-export-div"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to select all timelapse videos")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div-select-all disable-screeshots-select-all"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    name: "selectAll",
    type: "checkbox",
    label: "Select All",
    disabled: true
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div-select-all",
    onClick: function onClick(e) {
      return selectAll(e);
    }
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    name: "selectAll",
    type: "checkbox",
    label: "Select All",
    checked: selectAllButton === "checked",
    onChange: function onChange(e) {
      return selectAll(e);
    }
  }))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export timelapse videos")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-download-icon disable-screeshots-export"
  }, "Export")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "screenshot-download-icon"
    // disabled={exportLoad}
    ,
    onClick: function onClick() {
      getExportData();
    }
  }, exportLoad ? "Loading" : "Export"), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to delete multiple timelapse videos")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-download-icon disable-screeshots-export"
  }, "Delete")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "screenshot-download-delete-icon",
    onClick: function onClick() {
      handleBulkDeleteShow();
    }
  }, "Delete")) : null, isFutureRange ? /*#__PURE__*/React.createElement("div", {
    className: "timelapse-future-date-text"
  }, "Timelapse video is unavailable for the selected date(s).") : dateFilter === "Today" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timelapse-announcement-text"
  }, /*#__PURE__*/React.createElement("div", null, "Click on the ", /*#__PURE__*/React.createElement("span", {
    className: "timelapse-announcement-button-text"
  }, "Click to Generate Timelapse"), " ", "button to generate a video for any person. It will show you the estimated arrival time of the timelapse video.")), role == "Admin" ? /*#__PURE__*/React.createElement("div", {
    className: "timelapse-card-export-div"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to select all timelapse videos")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div-select-all disable-screeshots-select-all"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    name: "selectAll",
    type: "checkbox",
    label: "Select All",
    disabled: true
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-export-div-select-all",
    onClick: function onClick(e) {
      return selectAll(e);
    }
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    name: "selectAll",
    type: "checkbox",
    label: "Select All",
    checked: selectAllButton === "checked",
    onChange: function onChange(e) {
      return selectAll(e);
    }
  }))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export timelapse videos")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-download-icon disable-screeshots-export"
  }, "Export")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "screenshot-download-icon"
    // disabled={exportLoad}
    ,
    onClick: function onClick() {
      getExportData();
    }
  }, exportLoad ? "Loading" : "Export"), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) === "a7a46c38-5b8d-4d41-ac88-b3b4f051c04b" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to delete multiple timelapse videos")
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-download-icon disable-screeshots-export"
  }, "Delete")) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "screenshot-download-delete-icon",
    onClick: function onClick() {
      handleBulkDeleteShow();
    }
  }, "Delete")) : null, role == "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo || url || role == "Member" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserView, {
    videos: videos,
    startDate: startDate,
    endDate: endDate,
    handleShow: handleShow,
    headerName: headerName,
    role: role,
    generateTimelapseVideo: generateTimelapseVideo,
    generateTimelapseLoading: generateTimelapseLoading,
    organisationId: organisationId,
    startTime: startTime,
    endTime: endTime,
    user: user,
    tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    url: url,
    teamId: teamId,
    dateFilter: dateFilter,
    selectedVideoUrl: selectedVideoUrl,
    urls: urls,
    checkTimelapseVideo: checkTimelapseVideo,
    checkTimelapseVideoLoading: checkTimelapseVideoLoading,
    checkTimelapseVideoData: checkTimelapseVideoData,
    timelapseGeneratedData: timelapseGeneratedData,
    setTimelapseGeneratedData: setTimelapseGeneratedData,
    organisationSettings: organisationSettings
  })) : /*#__PURE__*/React.createElement(TeamView, {
    videos: videos,
    Link: Link,
    linkProps: linkProps,
    handleShow: handleShow,
    selectedVideoUrl: selectedVideoUrl,
    urls: urls,
    role: role,
    generateTimelapseVideo: generateTimelapseVideo,
    generateTimelapseLoading: generateTimelapseLoading,
    organisationId: organisationId,
    startTime: startTime,
    endTime: endTime,
    user: user,
    tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    url: url,
    teamId: teamId,
    dateFilter: dateFilter,
    timelapseLoading: timelapseLoading,
    timelapeFetchMore: timelapeFetchMore,
    checkTimelapseVideo: checkTimelapseVideo,
    checkTimelapseVideoLoading: checkTimelapseVideoLoading,
    checkTimelapseVideoData: checkTimelapseVideoData,
    timelapseGeneratedData: timelapseGeneratedData,
    setTimelapseGeneratedData: setTimelapseGeneratedData
    // addTimelapseResponse={addTimelapseResponse}
    // setAddTimelapseResponse={setAddTimelapseResponse}
  })) : !videos.length ? /*#__PURE__*/React.createElement("div", null, "No data found !!!") : !url && role !== "Member" && role == "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo || url || role == "Member" ? /*#__PURE__*/React.createElement(UserView, {
    videos: videos,
    startDate: startDate,
    endDate: endDate,
    handleShow: handleShow,
    headerName: headerName,
    role: role,
    generateTimelapseVideo: generateTimelapseVideo,
    generateTimelapseLoading: generateTimelapseLoading,
    organisationId: organisationId,
    startTime: startTime,
    endTime: endTime,
    user: user,
    tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    url: url,
    teamId: teamId,
    dateFilter: dateFilter,
    selectedVideoUrl: selectedVideoUrl,
    urls: urls,
    checkTimelapseVideo: checkTimelapseVideo,
    checkTimelapseVideoLoading: checkTimelapseVideoLoading,
    checkTimelapseVideoData: checkTimelapseVideoData,
    timelapseGeneratedData: timelapseGeneratedData,
    setTimelapseGeneratedData: setTimelapseGeneratedData,
    organisationSettings: organisationSettings
  }) : /*#__PURE__*/React.createElement(TeamView, {
    videos: videos,
    Link: Link,
    linkProps: linkProps,
    handleShow: handleShow,
    selectedVideoUrl: selectedVideoUrl,
    urls: urls,
    role: role,
    generateTimelapseVideo: generateTimelapseVideo,
    generateTimelapseLoading: generateTimelapseLoading,
    organisationId: organisationId,
    startTime: startTime,
    endTime: endTime,
    user: user,
    tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    url: url,
    teamId: teamId,
    dateFilter: dateFilter,
    timelapseLoading: timelapseLoading,
    timelapeFetchMore: timelapeFetchMore,
    checkTimelapseVideo: checkTimelapseVideo,
    checkTimelapseVideoLoading: checkTimelapseVideoLoading,
    checkTimelapseVideoData: checkTimelapseVideoData,
    timelapseGeneratedData: timelapseGeneratedData,
    setTimelapseGeneratedData: setTimelapseGeneratedData
    // addTimelapseResponse={addTimelapseResponse}
    // setAddTimelapseResponse={setAddTimelapseResponse}
  }))), /*#__PURE__*/React.createElement(VideoModal, {
    videosCount: (_videos = videos) === null || _videos === void 0 ? void 0 : _videos.length,
    selectedVideo: selectedVideo,
    onClose: handleClose,
    onNext: handleNext,
    onPrevious: handlePrevious
  }), /*#__PURE__*/React.createElement(BulkDeleteVideoModal, {
    showBulkDeleteModal: showBulkDeleteModal,
    handleBulkDeleteClose: handleBulkDeleteClose,
    userId: user.userId,
    url: url,
    startTime: startTime,
    endTime: endTime,
    role: role,
    urlIds: urlIds,
    setUrlIds: setUrlIds,
    organisationId: organisationId,
    teamId: teamId,
    setUrls: setUrls,
    dateFilter: dateFilter,
    tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationSettings: organisationSettings
  }));
};
var WarningCard = function WarningCard(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "waring-dashboard-card-pro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-text1"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "warning-dashboard-card-title-2nd-text-new warning-dashboard-card-title-2nd-text-new-font"
  }, "We are updating the Timelapse Video feature, and it is currently under maintenance. It will be available from 5th February."))))));
};
var TimelapseEnableFeature = function TimelapseEnableFeature(props) {
  var displayName = props.displayName,
    organisationId = props.organisationId,
    startTime = props.startTime,
    endTime = props.endTime,
    url = props.url,
    teamId = props.teamId,
    user = props.user,
    role = props.role,
    organisationSettings = props.organisationSettings;
  var _useMutation3 = useMutation(UPDATE_TIMELAPSE_SETTINGS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    updateTimelapseSettings = _useMutation4[0],
    timelapseSettingsLoading = _useMutation4[1].loading;
  var handleEnableTimelapseSettings = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!timelapseSettingsLoading) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return");
        case 2:
          _context3.next = 4;
          return updateTimelapseSettings({
            variables: {
              organisationId: organisationId
            },
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: TIMELAPSE_VIDEO_QUERY,
              variables: {
                startDate: startTime,
                endDate: endTime,
                organisationId: organisationId,
                teamId: !url ? teamId : null,
                userId: role === "Member" || role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? user.userId : null,
                url: role !== "Member" || role === "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? url : null,
                userRole: role
              }
            }, {
              query: WEB_ORGANISATION_SETTINGS_QUERY,
              variables: {
                organisationId: organisationId
              }
            }, {
              query: WORK_DAY_SETTINGS_QUERY,
              variables: {
                organisationId: organisationId
              }
            }]
          });
        case 4:
          response = _context3.sent;
          if (!(!response || !response.data || response.data.updateTimelapseSettings === false)) {
            _context3.next = 9;
            break;
          }
          throw new Error("error");
        case 9:
          toast.success("Setting enabled successfully!");
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [updateTimelapseSettings, timelapseSettingsLoading]);
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "timelapse-warning-text-p"
  }, "Hello ", displayName, ", you are yet to enable the timelapse feature. "), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "screenshot-enble-page",
    disabled: timelapseSettingsLoading,
    onClick: function onClick() {
      return handleEnableTimelapseSettings();
    }
  }, timelapseSettingsLoading ? "Updating..." : "Click to enable timelapse feature")), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text-document-link"
  }, "To know more about the timelapse video, pls refer", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/timelapse-video",
    target: "_blank"
  }, "this link.")));
};
var PlanUpdateMsgForAdmin = function PlanUpdateMsgForAdmin(props) {
  var organisationBilling = props.organisationBilling;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-header-card"
  }, /*#__PURE__*/React.createElement("p", {
    className: "PlanUpdateMsg-text"
  }, "Dear ", user.displayName, ", Please", " ", (props === null || props === void 0 ? void 0 : props.from) === "desktop" ? "contact your Team Admin" : "".concat((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) !== "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == true ? "purchase ".concat(organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName, " plan") : "upgrade your plan", " "), " ", "to use this page."), (props === null || props === void 0 ? void 0 : props.from) !== "desktop" ? /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-button-div"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "PlanUpdateMsg-button",
    onClick: function onClick() {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, "Visit Billing Page")) : null)), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text-document-link-free-user"
  }, "To know more about the timelapse video, pls refer", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/timelapse-video",
    target: "_blank"
  }, "this link.")));
};
var PlanUpdateMsgForUser = function PlanUpdateMsgForUser(props) {
  var organisationBilling = props.organisationBilling;
  var _React$useContext3 = React.useContext(UserContext),
    user = _React$useContext3.user;
  return /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-header-card"
  }, /*#__PURE__*/React.createElement("p", {
    className: "PlanUpdateMsg-text"
  }, "Dear ".concat(user.displayName, ", Your admin need to ").concat((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) !== "free" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.isTrial) == true ? "purchase ".concat(organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName, " plan") : "upgrade the plan", " to use this page. Contact your admin."))));
};
var TeamView = function TeamView(props) {
  var videos = props.videos,
    Link = props.Link,
    linkProps = props.linkProps,
    handleShow = props.handleShow,
    selectedVideoUrl = props.selectedVideoUrl,
    urls = props.urls,
    role = props.role,
    generateTimelapseVideo = props.generateTimelapseVideo,
    generateTimelapseLoading = props.generateTimelapseLoading,
    organisationId = props.organisationId,
    startTime = props.startTime,
    endTime = props.endTime,
    user = props.user,
    tz = props.tz,
    url = props.url,
    teamId = props.teamId,
    dateFilter = props.dateFilter,
    timelapseLoading = props.timelapseLoading,
    timelapeFetchMore = props.timelapeFetchMore,
    checkTimelapseVideo = props.checkTimelapseVideo,
    checkTimelapseVideoLoading = props.checkTimelapseVideoLoading,
    checkTimelapseVideoData = props.checkTimelapseVideoData,
    timelapseGeneratedData = props.timelapseGeneratedData,
    setTimelapseGeneratedData = props.setTimelapseGeneratedData;

  // load more state
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isAllLoaded = _React$useState18[0],
    setIsAllLoaded = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isLoadingMore = _React$useState20[0],
    setIsLoadingMore = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isLoadMoreButton = _React$useState22[0],
    setIsLoadMoreButton = _React$useState22[1];
  var _React$useState23 = React.useState([]),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    generateTimelapseUser = _React$useState24[0],
    setGenerateTimelapseUser = _React$useState24[1];
  var _React$useState25 = React.useState([]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    checkTimelapseGeneratedState = _React$useState26[0],
    setCheckTimelapseGeneratedState = _React$useState26[1];
  // const [isTimelapseDataAddedToCron, setIsTimelapseDataAddedToCron] = React.useState([]);

  var _React$useState27 = React.useState([]),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    addTimelapseResponse = _React$useState28[0],
    setAddTimelapseResponse = _React$useState28[1];

  // generateTimelapseUser => "loader for generate timelapse video button 1st click"
  // addTimelapseResponse => "generate timelapse video button 1st click"
  // checkTimelapseGeneratedState => "loader for check timelapse videp refresh button"
  // timelapseGeneratedData => "check timelapse video data"

  var handleTimelapseSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(userId, date) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            variables = {
              organisationId: organisationId,
              startDate: Number(moment(date).startOf("day").format("x")),
              endDate: Number(moment(date).endOf("day").format("x")),
              userId: userId,
              tz: tz,
              date: date,
              url: null
            };
            _context4.prev = 1;
            _context4.next = 4;
            return generateTimelapseVideo({
              variables: variables
            });
          case 4:
            response = _context4.sent;
            if (!(response && response.data && response.data.generateTimelapseVideo && response.data.generateTimelapseVideo.id !== null)) {
              _context4.next = 9;
              break;
            }
            if (response.data.generateTimelapseVideo.id != null) {
              // console.log({ generateTimelapseVideo: response.data.generateTimelapseVideo });

              setAddTimelapseResponse(function (prevData) {
                return [].concat(_toConsumableArray(prevData), [_objectSpread(_objectSpread({}, response.data.generateTimelapseVideo), {}, {
                  userId: userId
                })]);
              });

              // let isTimelapseDataAddedToCronTemp = addTimelapseResponse;

              // isTimelapseDataAddedToCronTemp.push({ ...response.data.generateTimelapseVideo, userId });

              // console.log({ addTimelapseResponse, isTimelapseDataAddedToCronTemp });

              // setAddTimelapseResponse(isTimelapseDataAddedToCronTemp);
            }
            _context4.next = 10;
            break;
          case 9:
            throw new Error("error");
          case 10:
            _context4.next = 16;
            break;
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](1);
            console.log({
              error: _context4.t0
            });
            toast.error("Error Occured, Try again later!");
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 12]]);
    }));
    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [generateTimelapseVideo, generateTimelapseLoading]);

  // console.log({ isTimelapseDataAddedToCron });

  var handleLoadMore = function handleLoadMore() {
    if (timelapseLoading) return;
    setIsLoadingMore(true);
    offset = offset + 1;
    timelapeFetchMore({
      variables: {
        offset: offset * LIMIT
      },
      // fetchPolicy: 'network-only',
      // notifyOnNetworkStatusChange: true,
      updateQuery: function updateQuery(prev, _ref5) {
        var _fetchMoreResult$time, _fetchMoreResult$time2;
        var fetchMoreResult = _ref5.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$time = fetchMoreResult.timelapseVideos) === null || _fetchMoreResult$time === void 0 ? void 0 : (_fetchMoreResult$time2 = _fetchMoreResult$time.timelapseVideos) === null || _fetchMoreResult$time2 === void 0 ? void 0 : _fetchMoreResult$time2.length) === 0 && fetchMoreResult.timelapseVideos.timelapseVideos.length < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          timelapseVideos: _objectSpread(_objectSpread({}, prev.timelapseVideos), {}, {
            timelapseVideos: [].concat(_toConsumableArray(prev.timelapseVideos.timelapseVideos), _toConsumableArray(fetchMoreResult.timelapseVideos.timelapseVideos))
          })
        });
      }
    });
  };
  var handleCheckTimelapseSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(organisationId, userId, date, tz) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            // let checkTimelapseGeneratedStateTemp = checkTimelapseGeneratedState;

            // setCheckTimelapseGeneratedState([...checkTimelapseGeneratedStateTemp, { userId, date }]);

            setCheckTimelapseGeneratedState(function (prevData) {
              return [].concat(_toConsumableArray(prevData), [{
                userId: userId,
                date: date
              }]);
            });
            _context5.next = 3;
            return checkTimelapseVideo({
              variables: {
                organisationId: organisationId,
                userId: userId,
                date: date,
                tz: tz
              }
            });
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function handleCheckTimelapseSubmit(_x3, _x4, _x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    if (!checkTimelapseVideoLoading && checkTimelapseVideoData !== null && checkTimelapseVideoData !== void 0 && checkTimelapseVideoData.checkTimelapseVideoGenerated && Object.keys(checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated).length) {
      var _checkTimelapseVideoD;
      var timelapseGeneratedDataTemp = timelapseGeneratedData.filter(function (object) {
        return moment(startTime).format("YYYY-MM-DD") !== moment(endTime).format("YYYY-MM-DD") && moment(object.date).format("YYYY-MM-DD") !== moment(checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated.date).format("YYYY-MM-DD") || moment(startTime).format("YYYY-MM-DD") == moment(endTime).format("YYYY-MM-DD") && object.userId != (checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated.userId);
      });
      setTimelapseGeneratedData([].concat(_toConsumableArray(timelapseGeneratedDataTemp), [_objectSpread({}, checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated)]));
      setCheckTimelapseGeneratedState([]);

      // let addTimelapseResponseTemp = addTimelapseResponse.filter((object) => {
      //   return (
      //     moment(object.date).format("YYYY-MM-DD") !==
      //     moment(checkTimelapseVideoData?.checkTimelapseVideoGenerated.date).format("YYYY-MM-DD")
      //   );
      // });

      // console.log({ addTimelapseResponseTemp });

      // setAddTimelapseResponse([...addTimelapseResponseTemp]);

      // generateTimelapseUser => "loader for generate timelapse video button 1st click"
      // addTimelapseResponse => "generate timelapse video button 1st click"
      // checkTimelapseGeneratedState => "loader for check timelapse videp refresh button"
      // timelapseGeneratedData => "check timelapse video data"

      if ((checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : (_checkTimelapseVideoD = checkTimelapseVideoData.checkTimelapseVideoGenerated) === null || _checkTimelapseVideoD === void 0 ? void 0 : _checkTimelapseVideoD.id) == null) {
        var _checkTimelapseVideoD2;
        toast.success("Pls wait, timelapse video will be generated after the ".concat(checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : (_checkTimelapseVideoD2 = checkTimelapseVideoData.checkTimelapseVideoGenerated) === null || _checkTimelapseVideoD2 === void 0 ? void 0 : _checkTimelapseVideoD2.estimationTime, "."));
      }
    }
  }, [checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated]);
  React.useEffect(function () {
    var generateTimelapseUserTemp = generateTimelapseUser.filter(function (_ref7) {
      var date = _ref7.date,
        userId = _ref7.userId;
      return !addTimelapseResponse.some(function (_ref8) {
        var date1 = _ref8.date,
          userId1 = _ref8.userId;
        return moment(date).format("YYYY-MM-DD") == moment(date1).format("YYYY-MM-DD") && userId == userId1;
      });
    });

    // const generateTimelapseUserTemp = generateTimelapseUser.filter((object) => {
    //   return moment(object.date).format("YYYY-MM-DD") !== moment(date).format("YYYY-MM-DD") && object.userId !== userId;
    // });

    setGenerateTimelapseUser(_toConsumableArray(generateTimelapseUserTemp));
  }, [addTimelapseResponse]);
  React.useEffect(function () {
    if ((videos === null || videos === void 0 ? void 0 : videos.length) !== 0 && (videos === null || videos === void 0 ? void 0 : videos.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [videos]);
  return /*#__PURE__*/React.createElement("div", {
    className: "timelapse-user-page-root"
  }, videos.map(function (user, index) {
    var _user$user;
    return /*#__PURE__*/React.createElement("div", {
      className: "timelapse-user-header-root-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timelapse-user-header-root"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "timelapse-user-header"
    }, /*#__PURE__*/React.createElement("span", {
      className: "timelapse-user-header-icon"
    }, /*#__PURE__*/React.createElement(HiUser, null)), /*#__PURE__*/React.createElement("span", null, user.user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "timelapse-see-more-card position-relative",
      key: user.user.userId
    }, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/timelapse/".concat(user.user.uniqueUrl)), {
      key: "team-".concat((_user$user = user.user) === null || _user$user === void 0 ? void 0 : _user$user.userId)
    }), /*#__PURE__*/React.createElement("span", {
      className: "timelapse-card-see-more-button"
    }, "See more")))), /*#__PURE__*/React.createElement("div", {
      className: "timelapse-cards-list"
    }, user.videoData.map(function (timelapseVideo, index) {
      var videoCount = user.videoData.length;
      var videoIndex = Number(index) + 1;
      var videoDetails = user.videoData;
      var status = timelapseVideo.status;
      var videoUrl = timelapseVideo.videoUrl;
      var id = timelapseVideo.id;
      var date = timelapseVideo.date;
      var durationInSecs = timelapseVideo.durationInSecs;
      var thumbnailUrl = timelapseVideo.thumbnailUrl;
      var estimationTime = timelapseVideo.estimationTime;
      var generateTimelapseUserState = generateTimelapseUser && (generateTimelapseUser === null || generateTimelapseUser === void 0 ? void 0 : generateTimelapseUser.find(function (video) {
        return moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD") && video.userId == user.user.userId;
      })) || {};
      var isTimelapseDataAddedToCronValue = addTimelapseResponse && (addTimelapseResponse === null || addTimelapseResponse === void 0 ? void 0 : addTimelapseResponse.find(function (video) {
        return moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD") && video.userId == user.user.userId;
      })) || {};
      if (addTimelapseResponse.length != 0 && Object.keys(isTimelapseDataAddedToCronValue).length > 0) {
        status = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.status;
        videoUrl = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.videoUrl;
        id = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.id;
        date = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.date;
        durationInSecs = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.durationInSecs;
        thumbnailUrl = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.thumbnailUrl;
        estimationTime = isTimelapseDataAddedToCronValue === null || isTimelapseDataAddedToCronValue === void 0 ? void 0 : isTimelapseDataAddedToCronValue.estimationTime;
      }
      var checkTimelapseGeneratedStateTemp = checkTimelapseVideoLoading && checkTimelapseGeneratedState && checkTimelapseGeneratedState.find(function (video) {
        var _user$user2;
        return video.userId == ((_user$user2 = user.user) === null || _user$user2 === void 0 ? void 0 : _user$user2.userId) && moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD");
      }) || {};
      var videoDetailsState = (timelapseGeneratedData === null || timelapseGeneratedData === void 0 ? void 0 : timelapseGeneratedData.find(function (video) {
        return moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD") && video.userId == user.user.userId;
      })) || {};
      if (Object.keys(videoDetailsState).length) {
        if (videoDetailsState.id != null) {
          status = videoDetailsState.status;
          videoUrl = videoDetailsState.videoUrl;
          id = videoDetailsState.id;
          date = videoDetailsState.date;
          durationInSecs = videoDetailsState.durationInSecs;
          thumbnailUrl = videoDetailsState.thumbnailUrl;
        }
        estimationTime = videoDetailsState.estimationTime;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card ".concat(status == "inactive" || videoUrl == null || videoUrl == "no_screenshot_found" ? "timelapse-card-no-timelapse" : ""),
        key: id
      }, status == "inactive" || videoUrl == null || videoUrl == "no_screenshot_found" || videoUrl == "cron_list" ? null : /*#__PURE__*/React.createElement("div", {
        className: "timelapse-header-card"
      }, role == "Admin" ? /*#__PURE__*/React.createElement(Form, {
        className: "image-heckbox"
      }, /*#__PURE__*/React.createElement(Form.Check, {
        inline: true,
        name: "group1",
        type: "checkbox",
        checked: urls ? urls.includes(videoUrl) : false,
        onChange: function onChange() {
          selectedVideoUrl(videoUrl, id, thumbnailUrl);
        }
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "timelapse-image-card position-relative ".concat(status == "inactive" || videoUrl == "no_screenshot_found" || videoUrl == "cron_list" ? "timelapse-image-card-play-no-timelapse" : videoUrl == null ? "timelapse-image-card-play-icon-timelapse" : ""),
        onClick: function onClick() {
          if (status == "active" && videoUrl != null && videoUrl != "no_screenshot_found" && videoUrl != "cron_list") {
            handleShow(timelapseVideo, videoIndex, user.user.displayName, user.user.profileUrl, videoCount, index, videoDetails);
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-video-play"
      }, Object.keys(generateTimelapseUserState).length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-video-generate-loading"
      }, /*#__PURE__*/React.createElement(Loader, null)) : videoUrl == "no_screenshot_found" ? /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-no-screenshot"
      }, "No Screenshot Found !!!") : videoUrl == "cron_list" ? /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-no-screenshot"
      }, /*#__PURE__*/React.createElement(MdTimelapse, {
        className: "timelapse-card-no-screenshot-icon"
      }), /*#__PURE__*/React.createElement("span", null, "Timelapse video is being generated"), /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-no-screenshot-estimated-time"
      }, /*#__PURE__*/React.createElement("span", {
        className: "timelapse-card-no-screenshot-estimated-time-label"
      }, "Estimated Time: ", estimationTime), /*#__PURE__*/React.createElement(OverlayTrigger, {
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "count-tooltip-start"
        }, "Refresh to check timelapse status")
      }, /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-no-screenshot-estimated-icon",
        onClick: function onClick(e) {
          if (!checkTimelapseVideoLoading) {
            var _user$user3;
            handleCheckTimelapseSubmit(organisationId, (_user$user3 = user.user) === null || _user$user3 === void 0 ? void 0 : _user$user3.userId, date, tz);
          }
        }
      }, /*#__PURE__*/React.createElement(MdRefresh, {
        className: "timelapse-card-refresh-icon ".concat(checkTimelapseVideoLoading && Object.keys(checkTimelapseGeneratedStateTemp).length ? "timelapse-card-refresh-icon-loading" : "")
      }))))) : status == "inactive" ? /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-no-screenshot timelapse-card-deleted"
      }, "Timelapse video deleted!") : videoUrl == null ? Object.keys(generateTimelapseUserState).length > 0 ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
        variant: "light",
        className: "timelapse-card-video-generate-icon",
        onClick: function onClick() {
          var _user$user4, _user$user5;
          var generateTimelapseUserTemp = generateTimelapseUser;
          setGenerateTimelapseUser([].concat(_toConsumableArray(generateTimelapseUserTemp), [{
            userId: (_user$user4 = user.user) === null || _user$user4 === void 0 ? void 0 : _user$user4.userId,
            date: date
          }]));
          handleTimelapseSubmit((_user$user5 = user.user) === null || _user$user5 === void 0 ? void 0 : _user$user5.userId, date);
        },
        disabled: Object.keys(generateTimelapseUserState).lenght > 0
      }, "Click to Generate Timelapse") : /*#__PURE__*/React.createElement(HiPlay, {
        className: "timelapse-card-play-icon"
        // onClick={() =>
        //   handleShow(
        //     timelapseVideo,
        //     videoIndex,
        //     user.user.displayName,
        //     user.user.profileUrl,
        //     videoCount,
        //     index,
        //     videoDetails
        //   )
        // }
      })), status == "inactive" || videoUrl == null || videoUrl == "no_screenshot_found" || videoUrl == "cron_list" ? /*#__PURE__*/React.createElement("div", {
        className: "timelapse-card-img timelapse-card-img-no-timelapse"
      }) : /*#__PURE__*/React.createElement("img", {
        src: thumbnailUrl,
        className: "timelapse-card-img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "timelapse-footer-card",
        onClick: function onClick() {
          return status != "inactive" && videoUrl != "no_screenshot_found" && videoUrl != "cron_list" && videoUrl != null ? handleShow(timelapseVideo, videoIndex, user.user.displayName, user.user.profileUrl, videoCount, index, videoDetails) : null;
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, formatDate(date)), durationInSecs ? /*#__PURE__*/React.createElement("span", {
        className: ""
      }, formatTime(durationInSecs)) : null));
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      //setIsLoadMoreButton(true);
      handleLoadMore();
    },
    disabled: timelapseLoading
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the employees")));
};
var UserView = function UserView(props) {
  var videos = props.videos,
    startDate = props.startDate,
    endDate = props.endDate,
    handleShow = props.handleShow,
    headerName = props.headerName,
    generateTimelapseVideo = props.generateTimelapseVideo,
    generateTimelapseLoading = props.generateTimelapseLoading,
    organisationId = props.organisationId,
    startTime = props.startTime,
    endTime = props.endTime,
    user = props.user,
    tz = props.tz,
    url = props.url,
    teamId = props.teamId,
    dateFilter = props.dateFilter,
    role = props.role,
    userId = props.userId,
    selectedVideoUrl = props.selectedVideoUrl,
    urls = props.urls,
    checkTimelapseVideo = props.checkTimelapseVideo,
    checkTimelapseVideoLoading = props.checkTimelapseVideoLoading,
    checkTimelapseVideoData = props.checkTimelapseVideoData,
    timelapseGeneratedData = props.timelapseGeneratedData,
    setTimelapseGeneratedData = props.setTimelapseGeneratedData,
    isTimelapseDataAddedToCron = props.isTimelapseDataAddedToCron,
    setIsTimelapseDataAddedToCron = props.setIsTimelapseDataAddedToCron,
    organisationSettings = props.organisationSettings;
  var dateFilterResult = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var _React$useState29 = React.useState([]),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    generateTimelapseUserView = _React$useState30[0],
    setGenerateTimelapseUserView = _React$useState30[1];
  var _React$useState31 = React.useState([]),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    checkTimelapseGeneratedState = _React$useState32[0],
    setCheckTimelapseGeneratedState = _React$useState32[1];
  var _React$useState33 = React.useState([]),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    generateTimelapseResponse = _React$useState34[0],
    setGenerateTimelapseResponse = _React$useState34[1];
  var handleTimelapseSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(userId, date) {
      var generateTimelapseUserTemp, variables, response, generateTimelapseResponseTemp;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            generateTimelapseUserTemp = [].concat(_toConsumableArray(generateTimelapseUserView), [{
              userId: userId,
              date: date
            }]);
            setGenerateTimelapseUserView(generateTimelapseUserTemp);
            variables = {
              organisationId: organisationId,
              startDate: Number(moment(date).startOf("day").format("x")),
              endDate: Number(moment(date).endOf("day").format("x")),
              userId: null,
              tz: tz,
              date: date,
              url: url
            };
            _context6.prev = 3;
            _context6.next = 6;
            return generateTimelapseVideo({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: TIMELAPSE_VIDEO_QUERY,
                variables: {
                  startDate: startTime,
                  endDate: endTime,
                  organisationId: organisationId,
                  teamId: !url ? teamId : null,
                  userId: role === "Member" || role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? user.userId : null,
                  url: role !== "Member" || role === "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? url : null,
                  userRole: role,
                  dateFilter: dateFilter,
                  tz: tz,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 6:
            response = _context6.sent;
            if (!(!response || !response.data || Object.keys(response.data.generateTimelapseVideo).length <= 0)) {
              _context6.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            generateTimelapseResponseTemp = [].concat(_toConsumableArray(generateTimelapseResponse), [_objectSpread({}, response.data.generateTimelapseVideo)]);
            setGenerateTimelapseResponse(generateTimelapseResponseTemp);
          case 13:
            _context6.next = 19;
            break;
          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](3);
            console.log({
              error: _context6.t0
            });
            toast.error("Error Occured, Try again later!");
          case 19:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[3, 15]]);
    }));
    return function (_x7, _x8) {
      return _ref10.apply(this, arguments);
    };
  }(), [generateTimelapseVideo, generateTimelapseLoading, generateTimelapseUserView, isTimelapseDataAddedToCron]);
  var handleCheckTimelapseSubmit = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(organisationId, userId, date, tz) {
      var checkTimelapseGeneratedStateTemp;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            checkTimelapseGeneratedStateTemp = checkTimelapseGeneratedState;
            setCheckTimelapseGeneratedState([].concat(_toConsumableArray(checkTimelapseGeneratedStateTemp), [{
              userId: userId,
              date: date
            }]));
            _context7.next = 4;
            return checkTimelapseVideo({
              variables: {
                organisationId: organisationId,
                userId: userId,
                date: date,
                tz: tz
              }
            });
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function handleCheckTimelapseSubmit(_x9, _x10, _x11, _x12) {
      return _ref11.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    var generateTimelapseUserTemp = generateTimelapseUserView.filter(function (object1) {
      var timelapseData = generateTimelapseResponse && generateTimelapseResponse.find(function (object) {
        return moment(object.date).format("YYYY-MM-DD") == moment(object1.date).format("YYYY-MM-DD");
      });
      if (timelapseData && Object.keys(timelapseData).length <= 0) {
        return object1;
      }
    });
    setGenerateTimelapseUserView(generateTimelapseUserTemp);
  }, [generateTimelapseResponse]);
  React.useEffect(function () {
    if (!checkTimelapseVideoLoading && checkTimelapseVideoData !== null && checkTimelapseVideoData !== void 0 && checkTimelapseVideoData.checkTimelapseVideoGenerated && Object.keys(checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated).length) {
      var _checkTimelapseVideoD3;
      var timelapseGeneratedDataTemp = timelapseGeneratedData.filter(function (object) {
        return moment(object.date).format("YYYY-MM-DD") !== moment(checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated.date).format("YYYY-MM-DD");
      });
      setTimelapseGeneratedData([].concat(_toConsumableArray(timelapseGeneratedDataTemp), [_objectSpread({}, checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated)]));
      setCheckTimelapseGeneratedState([]);
      if ((checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : (_checkTimelapseVideoD3 = checkTimelapseVideoData.checkTimelapseVideoGenerated) === null || _checkTimelapseVideoD3 === void 0 ? void 0 : _checkTimelapseVideoD3.id) == null) {
        var _checkTimelapseVideoD4;
        toast.success("Pls wait, timelapse video will be generated after the ".concat(checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : (_checkTimelapseVideoD4 = checkTimelapseVideoData.checkTimelapseVideoGenerated) === null || _checkTimelapseVideoD4 === void 0 ? void 0 : _checkTimelapseVideoD4.estimationTime, "."));
      }
    }
  }, [checkTimelapseVideoData === null || checkTimelapseVideoData === void 0 ? void 0 : checkTimelapseVideoData.checkTimelapseVideoGenerated]);
  return /*#__PURE__*/React.createElement("div", {
    className: "timelapse-user-header-root-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timelapse-cards-list"
  }, videos[0].videoData.length ? videos[0].videoData.map(function (timelapseVideo, index) {
    var videoCount = videos[0].videoData.length;
    var videoIndex = Number(index) + 1;
    var videoDetails = videos[0].videoData;
    var status = timelapseVideo.status;
    var videoUrl = timelapseVideo.videoUrl;
    var id = timelapseVideo.id;
    var date = timelapseVideo.date;
    var durationInSecs = timelapseVideo.durationInSecs;
    var thumbnailUrl = timelapseVideo.thumbnailUrl;
    var estimationTime = timelapseVideo.estimationTime;

    // generateTimelapseUser;

    var generateTimelapseUserState = generateTimelapseUserView && (generateTimelapseUserView === null || generateTimelapseUserView === void 0 ? void 0 : generateTimelapseUserView.find(function (video) {
      return moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD");
    })) || {};
    var videoDetailsState = (timelapseGeneratedData === null || timelapseGeneratedData === void 0 ? void 0 : timelapseGeneratedData.find(function (video) {
      return moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD");
    })) || {};
    if (Object.keys(videoDetailsState).length) {
      estimationTime = videoDetailsState.estimationTime;
      if (videoDetailsState.id != null) {
        status = videoDetailsState.status;
        videoUrl = videoDetailsState.videoUrl;
        id = videoDetailsState.id;
        date = videoDetailsState.date;
        durationInSecs = videoDetailsState.durationInSecs;
        thumbnailUrl = videoDetailsState.thumbnailUrl;
      }
    }
    var checkTimelapseGeneratedStateTemp = checkTimelapseVideoLoading && (checkTimelapseGeneratedState === null || checkTimelapseGeneratedState === void 0 ? void 0 : checkTimelapseGeneratedState.find(function (video) {
      var _videos$2;
      return moment(video.date).format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD") && video.userId == ((_videos$2 = videos[0]) === null || _videos$2 === void 0 ? void 0 : _videos$2.user.userId);
    })) || {};
    return /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card ".concat(status == "inactive" || videoUrl == null || videoUrl == "no_screenshot_found" ? "timelapse-card-no-timelapse" : videoUrl == null ? "timelapse-image-card-play-icon-timelapse" : ""),
      key: id
    }, status == "inactive" || videoUrl == null || videoUrl == "no_screenshot_found" || videoUrl == "cron_list" ? null : /*#__PURE__*/React.createElement("div", {
      className: "timelapse-header-card"
    }, role == "Admin" ? /*#__PURE__*/React.createElement(Form, {
      className: "image-heckbox"
    }, /*#__PURE__*/React.createElement(Form.Check, {
      inline: true,
      name: "group1",
      type: "checkbox",
      checked: urls ? urls.includes(videoUrl) : false,
      onChange: function onChange() {
        selectedVideoUrl(videoUrl, id, thumbnailUrl);
      }
    })) : null), /*#__PURE__*/React.createElement("div", {
      className: "timelapse-image-card position-relative ".concat(status == "inactive" || videoUrl == "no_screenshot_found" || videoUrl == "cron_list" ? "timelapse-image-card-play-no-timelapse" : videoUrl == null ? "timelapse-image-card-play-icon-timelapse" : ""),
      onClick: function onClick() {
        if (status == "active" && videoUrl != null && videoUrl != "no_screenshot_found" && videoUrl != "cron_list") {
          var _videos$3;
          handleShow(timelapseVideo, videoIndex, headerName, (_videos$3 = videos[0]) === null || _videos$3 === void 0 ? void 0 : _videos$3.user.profileUrl, videoCount, index, videoDetails);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-video-play"
    }, generateTimelapseLoading && Object.keys(generateTimelapseUserState).length ? /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-video-generate-loading"
    }, /*#__PURE__*/React.createElement(Loader, null)) : videoUrl == "no_screenshot_found" ? /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-no-screenshot"
    }, "No Screenshot Found !!!") : videoUrl == "cron_list" ? /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-no-screenshot"
    }, /*#__PURE__*/React.createElement(MdTimelapse, {
      className: "timelapse-card-no-screenshot-icon"
    }), /*#__PURE__*/React.createElement("span", null, "Timelapse video is being generated"), /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-no-screenshot-estimated-time"
    }, /*#__PURE__*/React.createElement("span", {
      className: "timelapse-card-no-screenshot-estimated-time-label"
    }, "Estimated Time: ", estimationTime), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Refresh to check timelapse status")
    }, /*#__PURE__*/React.createElement("span", {
      className: "timelapse-card-no-screenshot-estimated-icon",
      onClick: function onClick(e) {
        if (!checkTimelapseVideoLoading) {
          var _videos$4, _videos$4$user;
          handleCheckTimelapseSubmit(organisationId, (_videos$4 = videos[0]) === null || _videos$4 === void 0 ? void 0 : (_videos$4$user = _videos$4.user) === null || _videos$4$user === void 0 ? void 0 : _videos$4$user.userId, date, tz);
        }
      }
    }, /*#__PURE__*/React.createElement(MdRefresh, {
      className: "timelapse-card-refresh-icon ".concat(checkTimelapseVideoLoading && Object.keys(checkTimelapseGeneratedStateTemp).length ? "timelapse-card-refresh-icon-loading" : "")
    }))))) : status == "inactive" ? /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-no-screenshot timelapse-card-deleted"
    }, "Timelapse video deleted!") : videoUrl == null ? generateTimelapseLoading && Object.keys(generateTimelapseUserState).length ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
      variant: "light",
      className: "timelapse-card-video-generate-icon",
      onClick: function onClick() {
        var _videos$5, _videos$5$user;
        handleTimelapseSubmit((_videos$5 = videos[0]) === null || _videos$5 === void 0 ? void 0 : (_videos$5$user = _videos$5.user) === null || _videos$5$user === void 0 ? void 0 : _videos$5$user.userId, date);
      },
      disabled: generateTimelapseLoading && Object.keys(generateTimelapseUserState).length
    }, "Click to Generate Timelapse") :
    /*#__PURE__*/
    // </OverlayTrigger>
    React.createElement(HiPlay, {
      className: "timelapse-card-play-icon"
      // onClick={() =>
      //   handleShow(
      //     timelapseVideo,
      //     videoIndex,
      //     headerName,
      //     videos[0].user.profileUrl,
      //     videoCount,
      //     index,
      //     videoDetails
      //   )
      // }
    })), status == "inactive" || videoUrl == null || videoUrl == "no_screenshot_found" || videoUrl == "cron_list" ? /*#__PURE__*/React.createElement("div", {
      className: "timelapse-card-img timelapse-card-img-no-timelapse"
    }) : /*#__PURE__*/React.createElement("img", {
      src: thumbnailUrl,
      className: "timelapse-card-img"
    })), /*#__PURE__*/React.createElement("div", {
      className: "timelapse-footer-card"
    }, /*#__PURE__*/React.createElement("span", {
      className: ""
    }, formatDate(date)), durationInSecs ? /*#__PURE__*/React.createElement("span", {
      className: ""
    }, formatTime(durationInSecs)) : null));
  }) : /*#__PURE__*/React.createElement("div", null, "No data found !!!")));
};
var VideoModal = function VideoModal(props) {
  var selectedVideo = props.selectedVideo,
    onClose = props.onClose,
    onNext = props.onNext,
    onPrevious = props.onPrevious;
  if (!selectedVideo) {
    return null;
  }
  var videoUrl = selectedVideo.videoUrl,
    videoIndex = selectedVideo.videoIndex,
    date = selectedVideo.date,
    durationInSecs = selectedVideo.durationInSecs,
    displayName = selectedVideo.displayName,
    profileUrl = selectedVideo.profileUrl,
    videoCount = selectedVideo.videoCount;
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: onClose,
    className: "timelapse-video-modal",
    size: "xl"
  }, /*#__PURE__*/React.createElement("span", {
    className: "timelapse-video-modal-close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(HiOutlineX, null)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "timelapse-video-modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timelapse-video-modal-personal-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timelapse-video-modal-personal-header-details"
  }, profileUrl === null || profileUrl === "" ? /*#__PURE__*/React.createElement("div", {
    className: "timelapse-video-modal-site-icon-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timelapse-video-modal-site-icon"
  }, displayName.charAt(0).toUpperCase())) : /*#__PURE__*/React.createElement("div", {
    className: "timelapse-modal-avatar-profile"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: profileUrl,
    className: "timelapse-modal-avatar-profile-img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "timelapse-video-modal-site-icon-details"
  }, /*#__PURE__*/React.createElement("span", {
    className: "timelapse-video-modal-site-name"
  }, displayName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "timelapse-video-modal-user-name"
  }, formatDate(date)))), /*#__PURE__*/React.createElement("div", {
    className: "timelapse-video-modal-time-details"
  }, /*#__PURE__*/React.createElement(HiOutlineClock, {
    className: "timelapse-video-modal-time-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "timelapse-video-modal-time"
  }, formatTime(durationInSecs)))), videoIndex !== videoCount && videoIndex > 1 ? /*#__PURE__*/React.createElement(HiArrowCircleLeft, {
    className: "timelapse-video-modal-left-nav",
    onClick: onPrevious
  }) : null, /*#__PURE__*/React.createElement("video", {
    width: "100%",
    height: "100%",
    controls: true,
    controlsList: "nodownload",
    disablePictureInPicture: true
    // autoPlay
  }, /*#__PURE__*/React.createElement("source", {
    src: videoUrl,
    type: "video/mp4"
  })), videoIndex !== videoCount && videoIndex < videoCount ? /*#__PURE__*/React.createElement(HiArrowCircleRight, {
    className: "timelapse-video-modal-right-nav",
    onClick: onNext
  }) : null));
};
function formatDate(date) {
  return moment(date).calendar({
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    lastWeek: "[Last] dddd",
    sameElse: "ll"
  });
}
function formatTime(timeInSecs) {
  timeInSecs = Number(timeInSecs);
  var h = Math.floor(timeInSecs / 3600);
  var m = Math.floor(timeInSecs % 3600 / 60);
  var s = Math.floor(timeInSecs % 3600 % 60);
  var hDisplay = h > 0 ? h > 10 ? h : "0".concat(h) : null;
  var mDisplay = m > 10 ? m : "0".concat(m);
  var sDisplay = s > 10 ? s : "0".concat(s);
  return [hDisplay, mDisplay, sDisplay].filter(function (f) {
    return f;
  }).join(":");
}
var BulkDeleteVideoModal = function BulkDeleteVideoModal(props) {
  var showBulkDeleteModal = props.showBulkDeleteModal,
    handleBulkDeleteClose = props.handleBulkDeleteClose,
    setUrlIds = props.setUrlIds,
    urlIds = props.urlIds,
    organisationId = props.organisationId,
    teamId = props.teamId,
    setUrls = props.setUrls,
    startTime = props.startTime,
    endTime = props.endTime,
    url = props.url,
    userId = props.userId,
    role = props.role,
    dateFilter = props.dateFilter,
    tz = props.tz,
    organisationSettings = props.organisationSettings;
  if (showBulkDeleteModal === null && urlIds.length === 0) {
    return null;
  }
  var _React$useState35 = React.useState(null),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    deleteStatus = _React$useState36[0],
    setDeleteStatus = _React$useState36[1];
  var _useMutation5 = useMutation(DELETE_TIMELAPSE_VIDEOS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    deleteBulkTimelapse = _useMutation6[0],
    deleteTimelapseLoading = _useMutation6[1].loading;
  var handleDeleteTimelapse = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!deleteTimelapseLoading) {
            _context8.next = 2;
            break;
          }
          return _context8.abrupt("return");
        case 2:
          _context8.next = 4;
          return deleteBulkTimelapse({
            variables: {
              organisationId: organisationId,
              videoIds: urlIds
            },
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: TIMELAPSE_VIDEO_QUERY,
              variables: {
                startDate: startTime,
                endDate: endTime,
                organisationId: organisationId,
                teamId: !url ? teamId : null,
                userId: role === "Member" || role === "Head" && !organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? userId : null,
                url: role !== "Member" || role === "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? url : null,
                userRole: role,
                dateFilter: dateFilter,
                tz: tz,
                limit: LIMIT,
                offset: offset
              }
            }]
          });
        case 4:
          response = _context8.sent;
          if (!response || !response.data || response.data.deleteBulkTimelapse === false) {
            setDeleteStatus("error");
            toast.error("Error Occured, Try again later!");
          } else {
            setDeleteStatus(true);
            setUrlIds([]);
            setUrls([]);
            handleBulkDeleteClose();
            toast.success("Timelapse video deleted successfully!");
          }
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  })), [deleteBulkTimelapse, deleteTimelapseLoading, urlIds]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showBulkDeleteModal,
    onHide: handleBulkDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Timelapse")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, "Are you sure to delete the selected ", urlIds.length === 1 ? "timelapse" : "timelapse's", "? Deleted", " ", urlIds.length === 1 ? "timelapse" : "timelapse's", " can't be retrieved.", /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-delete-task-name-text"
  }, " ", "It will take a few seconds to delete the timelapse in our cloud.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleBulkDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleDeleteTimelapse();
    },
    disabled: deleteTimelapseLoading
  }, deleteStatus === true ? "Deleted" : deleteTimelapseLoading ? "Deleting" : urlIds.length === 1 ? "Delete Timelapse" : "Delete Timelapse's")));
};
var TimelapseWrapper = function TimelapseWrapper(props) {
  var _React$useContext4 = React.useContext(FilterContext),
    teamId = _React$useContext4.teamId,
    organisationId = _React$useContext4.organisationId,
    startDate = _React$useContext4.startDate,
    endDate = _React$useContext4.endDate,
    organisationSettings = _React$useContext4.organisationSettings,
    role = _React$useContext4.role,
    organisationMenuList = _React$useContext4.organisationMenuList,
    organisationBilling = _React$useContext4.organisationBilling,
    from = _React$useContext4.from,
    organisationStatus = _React$useContext4.organisationStatus;
  React.useEffect(function () {
    if (role == "Member" && (organisationSettings.allowMemberToAccessScreenCapture == false || organisationSettings.allowMemberToAccessTimelapseVideo == false)) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
    if (from == "web" && role == "Member" && !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.generateTimelapseVideo)) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);

  //&& role != "Member"

  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && from === "web" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);

  // organisationMenuList.indexOf("Timelapse Videos") === -1 ||

  return role === "Admin" || role === "Head" && organisationSettings.allowHeadToAccessTheirTeamMemberScreenCaptureAndTimelapseVideo ? /*#__PURE__*/React.createElement(React.Fragment, null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) !== "free" && organisationBilling.isTrial == true && organisationId != "9c5f6520-f8fb-11ec-90c3-a72cd085f85b" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? /*#__PURE__*/React.createElement(PlanUpdateMsgForAdmin, _extends({}, props, {
    organisationBilling: organisationBilling
  })) : /*#__PURE__*/React.createElement(UserSidemenu, {
    history: props.history,
    match: props.match
  }, function (user) {
    return /*#__PURE__*/React.createElement(Timelapse, _extends({
      user: user
    }, props, {
      teamId: teamId,
      organisationId: organisationId,
      startDate: startDate,
      endDate: endDate,
      organisationSettings: organisationSettings,
      role: role,
      organisationBilling: organisationBilling
    }));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) !== "free" && organisationBilling.isTrial == true ? /*#__PURE__*/React.createElement(PlanUpdateMsgForUser, _extends({}, props, {
    organisationBilling: organisationBilling
  })) : /*#__PURE__*/React.createElement(Timelapse, _extends({
    user: null
  }, props, {
    teamId: teamId,
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    organisationSettings: organisationSettings,
    role: role,
    organisationBilling: organisationBilling
  })));
};
export default TimelapseWrapper;